import { render, staticRenderFns } from "./Warranty.vue?vue&type=template&id=4ec49b22&scoped=true&"
var script = {}
import style0 from "./Warranty.vue?vue&type=style&index=0&id=4ec49b22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec49b22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ec49b22')) {
      api.createRecord('4ec49b22', component.options)
    } else {
      api.reload('4ec49b22', component.options)
    }
    module.hot.accept("./Warranty.vue?vue&type=template&id=4ec49b22&scoped=true&", function () {
      api.rerender('4ec49b22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Ssl/Warranty.vue"
export default component.exports